
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Assessment } from '@/types/assessment';
import { FileCheck, Archive, Save } from 'lucide-react';

interface EditAssessmentActionsProps {
  id: string;
  loading: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onPublish?: (e: React.MouseEvent) => void;
  assessment?: Assessment | null;
}

export function EditAssessmentActions({ 
  id, 
  loading, 
  onSubmit, 
  onPublish,
  assessment
}: EditAssessmentActionsProps) {
  const navigate = useNavigate();
  
  return (
    <div className="flex gap-4">
      {assessment?.status === 'draft' ? (
        <>
          <Button 
            type="submit" 
            disabled={loading} 
            onClick={onSubmit}
          >
            <Save className="h-4 w-4 mr-2" />
            Save Draft
          </Button>

          {onPublish && (
            <Button 
              type="button" 
              disabled={loading} 
              onClick={onPublish}
              className="bg-green-600 hover:bg-green-700"
            >
              <FileCheck className="h-4 w-4 mr-2" />
              Publish Assessment
            </Button>
          )}
        </>
      ) : (
        <Button type="submit" disabled={loading} onClick={onSubmit}>
          {assessment?.status === 'published' 
            ? 'Update Assessment' 
            : 'Save Draft'}
        </Button>
      )}
      
      <Button 
        type="button" 
        variant="outline" 
        onClick={() => navigate(`/admin/assessments/${id}`)}
      >
        Cancel
      </Button>
    </div>
  );
}
